export default __webpack_public_path__ + "static/media/admin.b34dd0ef.png";